import Reflux from 'reflux';

export default Reflux.createActions([
  'reset',
  'updateProjects',
  'updateDateTime',
  'updateEnvironments',
]);
